import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { IFilterFacet, IFilterFacetItem } from '@impact/data';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SwiperComponent } from 'swiper/angular';

import { FilterService } from '../../filter-service/filter.service';
import { FeatureDetectionService } from '../../utils/helpers/feature-detection.service';

@Component({
    selector: 'app-highlighted-facet',
    template: `
        <div class="highlighted-facet" *ngIf="facet?.items?.length && isBrowser"
            [ngClass]="{
                'is-active': isActive,
                'is-fetching': isFetching
            }">
            <!-- <app-fade-in> -->
                <swiper class="highlighted-facet__list animate-fade-in"
                    #swiper
                    [slidesPerView]="'auto'"
                    [slidesPerGroup]="slidesPerGroup"
                    [initialSlide]="1"
                    [speed]="500"
                    [direction]="'horizontal'"
                    [navigation]="true"
                    [spaceBetween]="10">
                    <ng-template swiperSlide *ngFor="let facetOption of facet?.items">
                        <button
                            type="button"
                            class="button--square highlighted-facet__button"
                            (click)="handleChange(facetOption)">
                            <span>{{facetOption.label}}</span>
                        </button>
                    </ng-template>
                </swiper>
            <!-- </app-fade-in> -->
        </div>
    `,
})
export class HighlightedFacetComponent implements OnInit, OnChanges, OnDestroy {
    @Input() facetKey: string;
    @Input() facet: IFilterFacet;
    @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
    isActive: boolean;
    isFetching: boolean;
    slidesPerGroup = 3;
    isBrowser: boolean;

    private readonly unsubscribe = new Subject<void>();

    constructor(
        public readonly filterService: FilterService,
        private breakpointObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        private readonly featureDetectionService: FeatureDetectionService
    ) {
        this.isBrowser = this.featureDetectionService.isBrowser();
    }

    ngOnInit() {
        // Detect layout changes
        const queries$ = this.breakpointObserver.observe([
            '(min-width: 460px)',
            '(min-width: 768px)',
            '(min-width: 1024px)',
            '(min-width: 1200px)',
            '(min-width: 1580px)'
        ]);

        queries$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((result) => {

                if (!result.matches) {
                    this.slidesPerGroup = 2;
                } else {
                    if (result.breakpoints['(min-width: 1580px)'] === true) {
                        this.slidesPerGroup = 6;
                    } else if (result.breakpoints['(min-width: 1200px)'] === true) {
                        this.slidesPerGroup = 6;
                    } else if (result.breakpoints['(min-width: 1024px)'] === true) {
                        this.slidesPerGroup = 5;
                    } else if (result.breakpoints['(min-width: 768px)'] === true) {
                        this.slidesPerGroup = 4;
                    } else if (result.breakpoints['(min-width: 460px)'] === true) {
                        this.slidesPerGroup = 3;
                    }
                }

                this.cdr.detectChanges();
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.isBrowser) {
            if (changes.facet.previousValue === changes.facet.currentValue) {
                this.isActive = true;
                return;
            }

            if (this.facet.items) {
                this.facet.items = this.facet.items.sort((a: any, b: any) => b.count - a.count);
            }

            this.isActive = true;
            this.isFetching = false;
            this.swiper?.swiperRef.slideTo(0,0,false)
        }
    }

    handleChange(option: IFilterFacetItem) {
        this.isActive = false;
        this.isFetching = true;
        this.filterService.setFacet({ facet: this.facetKey, option });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
